import React from 'react';
import { useNavigate } from 'react-router-dom';
import { C, DISP, BODY, FadeUp, SECTION_PAD, useSectionView, track, scrollToId } from './shared';

export const FinalCTASection = () => {
  const navigate = useNavigate();
  const ref = useSectionView('final_cta');
  return (
    <section ref={ref} style={{ padding: SECTION_PAD }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <FadeUp>
          <div style={{
            position: 'relative', padding: 'clamp(48px, 8vw, 88px) clamp(24px, 5vw, 64px)',
            borderRadius: 24, border: `1px solid ${C.borderLime}`,
            background: 'linear-gradient(180deg, rgba(200,241,53,0.04), rgba(0,0,0,0.3))',
            textAlign: 'center', overflow: 'hidden',
          }}>
            <div style={{ position: 'absolute', top: 0, left: 24, right: 24, height: 1, background: 'linear-gradient(90deg, transparent, rgba(200,241,53,0.5), transparent)' }} />
            <div aria-hidden="true" style={{ position: 'absolute', top: -100, left: '50%', transform: 'translateX(-50%)', width: 600, height: 300, background: 'radial-gradient(ellipse, rgba(200,241,53,0.16), transparent 70%)', filter: 'blur(20px)', pointerEvents: 'none' }} />

            <h2 style={{ fontFamily: DISP, fontWeight: 800, fontSize: 'clamp(32px, 5.6vw, 64px)', letterSpacing: '-0.03em', lineHeight: 1.06, color: C.text, position: 'relative' }}>
              You don&rsquo;t need more marketing tools.<br />
              <span style={{ color: C.lime }}>You need to know what to do next.</span>
            </h2>

            <div style={{ marginTop: 36, display: 'flex', flexWrap: 'wrap', gap: 14, justifyContent: 'center', position: 'relative' }}>
              <button onClick={() => { track('final_cta_clicked', { cta: 'scan' }); scrollToId('scanner'); }} data-testid="final-cta" className="scl-btn-primary">
                Scan my brand free →
              </button>
              <button onClick={() => { track('final_cta_clicked', { cta: 'register' }); navigate('/register'); }} data-testid="final-cta-register" className="scl-btn-ghost">
                Start free
              </button>
            </div>

            <p style={{ marginTop: 24, fontFamily: BODY, fontSize: 13.5, color: C.muted, position: 'relative' }}>
              No card required &middot; Start with a plan built around your business
            </p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};
